module.exports = __webpack_public_path__ + "img/purple-1-diamond-striped.00fd5b1b.svg";